export default {
  mainContainer: 'bg-color-bg w-[100%] min-h-[100vh]',
  container: 'max-w-[1440px] mx-auto px-[5vw]',
  contentContainer: 'flex items-center justify-center pt-32',
  contentWrapper: 'max-w-[473px] px-[32px] py-[42px] rounded-3xl bg-color-white',
  title: 'font-interSemibold text-[32px] text-[#101828] mb-4',
  info: 'font-inter text-base text-[#585D69] mb-8',
  button: 'mt-[28px] mb-[32px]',
  wrapper: 'flex gap-[8px]',
  goBack: 'font-inter text-base text-[#585D69]',
  logIn: 'font-interSemibold text-base text-[#00518B]',
};
